<template>
  <v-dialog v-model="show" width="60vw" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Actualizar OP {{ orderToUpdate.serial }}</v-card-title>
      <v-card-text>
        <v-container>
          <v-row justify="end">
            <v-col cols="12" xl="3" lg="4" md="5">
              <v-btn color="primary" block rounded @click="showNotificationModal = true">
                <v-icon> mdi-bell-cog </v-icon>
                Enviar notificación
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-form ref="loteForm" lazy-validation>
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field label="Nombre del cliente" dense outlined clearable :rules="validation()" type="text"
                      v-model="client"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-combobox label="Selecciona tipo de venta" dense outlined clearable :rules="validation()"
                      type="text" item-text="name" :items="saleTypes" return-object v-model="saleType"></v-combobox>
                  </v-col>
                  <v-col>
                    <v-autocomplete label="Selecciona el destino" dense outlined clearable type="text" item-text="name"
                      no-data-text="Dirección no encontrada" :items="addressList" return-object v-model="address"
                      :loading="retrievingAddressList" :search-input.sync="searchAddress"></v-autocomplete>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field label="Nombre de etiqueta" dense outlined clearable type="text"
                      v-model="label"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-textarea outlined name="input-7-4" label="Observaciones generales"
                      v-model="observations"></v-textarea>
                  </v-col>

                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal()" dark :disabled="isLoading">Cerrar</v-btn>
            </v-col>
            <v-col>
              <v-btn color="primary" @click="updateOPRequest" :loading="isLoading" block>
                Actualizar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <UpdateDelivery v-model="showUpdateDelivery" @update="updateData()" v-if="showUpdateDelivery" />
    <AddDeliveryOP v-model="showAddDeliveryOP" @update="updateData()" v-if="showAddDeliveryOP" />
    <NotificationModal v-model="showNotificationModal" v-if="showNotificationModal" />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations, mapState } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation, requiredMultiple } from "@/helpers/validations.js";
// date library
import dayjs from "dayjs";
//components
import AddDeliveryOP from "@/components/dashboard/production-orders/modals/AddDeliveryOP.vue";
import NotificationModal from "@/components/dashboard/production-orders/modals/NotificationModal.vue";
import UpdateDelivery from "@/components/dashboard/production-orders/modals/UpdateDelivery.vue";

export default {
  components: {
    AddDeliveryOP,
    NotificationModal,
    UpdateDelivery,
  },
  data: () => ({
    isLoading: false,
    user: JSON.parse(localStorage.getItem("user")),
    showAddDeliveryOP: false,
    showNotificationModal: false,
    showUpdateDelivery: false,
    client: null,
    saleType: null,
    label: null,
    saleTypes: [
      { name: "R", value: "R" },
      { name: "OP", value: "OP" },
      { name: "P", value: "P" },
      { name: "OR", value: "OR" },
      { name: "I", value: "I" },
      { name: "M", value: "M" },
      { name: "KIT", value: "KIT" },
    ],
    orderDeliveries: [],
    fetchingData: false,
    page: 1,
    search: null,
    filters: null,
    numPages: 1,
    expanded: [],
    observations: null,
    addressList: [],
    address: null,
    searchAddress: null,
    retrievingAddressList: false
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("order", ["orderToUpdate"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async created() {
    this.client = this.orderToUpdate.client;
    this.saleType = this.orderToUpdate.saleType;
    this.label = this.orderToUpdate.label;
    this.observations = this.orderToUpdate.observations;
    if (this.orderToUpdate.address) {
      this.searchAddress = this.orderToUpdate.address.name
      await this.getAddressList()
      this.address = this.orderToUpdate.address
    } else {
      await this.getAddressList()
    }

    await this.fetchData();
  },
  methods: {
    ...mapActions("order", [
      "getDeliverytOrders",
      "updateOP",
      "sendNotificationLoteEvent",
    ]),
    ...mapMutations("order", [
      "SET_DELIVERY_OP_TO_UPDATE",
      "SET_ORDER_TO_UPDATE",
    ]),
    ...mapActions("address", ["getAddress"]),
    closeModal() {
      this.SET_ORDER_TO_UPDATE(null);
      this.$emit("update");
      this.show = false;
    },
    async updateOPRequest() {
      //emit fetch table
      if (this.$refs.loteForm.validate()) {
        try {
          this.isLoading = true;
          let payload = {
            client: this.client,
            user: this.user,
            saleType: this.saleType.value,
            label: this.label,
            order: this.orderToUpdate._id,
            observations: this.observations,
            address: this.address
          };

          await this.updateOP(payload);

          this.$swal({
            icon: "success",
            title: `OP actualizada`,
            showConfirmButton: false,
            timer: 500,
          });
          this.$emit("update");
          // this.show = false;
        } catch (e) {
          console.log(e);
          this.$swal({
            icon: "error",
            title: `Algo salio mal al actualizar OP`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        this.fetchingData = true;
        let response = await this.getDeliverytOrders({
          page: this.page,
          search: this.search,
          filters: this.filters,
          orderId: this.orderToUpdate._id,
        });

        if (response) {
          if (!response.error) {
            this.orderDeliveries = response.deliveryOrders;
            // this.SET_ORDER_EVENTS(response.orders);
            this.numPages = response.pages;
          } else {
            this.$swal({
              icon: "error",
              title: `Algo salio mal al cargar ordenes`,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar ordenes`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar ordenes`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.fetchingData = false;
    },
    updateDelivery(item) {
      if (item) {
        this.showUpdateDelivery = true;
      } else {
        this.showAddDeliveryOP = true;
      }
      this.SET_DELIVERY_OP_TO_UPDATE(item);
    },
    async updateData() {
      await this.fetchData();
      this.showAddDeliveryOP = false;
    },
    validation(name) {
      return requiredValidation(name);
    },
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    async getAddressList() {
      try {
        this.retrievingAddressList = true
        let payload = {
          search: this.searchAddress,
          rowPerPage: 20
        }
        let response = await this.getAddress(payload)
        this.addressList = response.addressList
      } catch (error) {
        console.log(error);
      } finally {
        this.retrievingAddressList = false
      }
    }
  },
  watch: {
    async search() {
      this.page = 1;
      this.fetchData();
    },
    async page() {
      await this.fetchData();
    },
    async searchAddress() {
      await this.getAddressList()
    }
  },
};
</script>

<style scoped>
.decrease {
  background-color: red;
  color: white;
}
</style>
